import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import VehicleElement from "../../components/vehicleElement";
import "./styles.css";
import { Tab, Tabs } from "react-bootstrap";
import { post } from "../../components/api";
import Translate from "../../components/Translate";
import Loading from "../../components/Loading";
//import SocketIOComponent from "../../components/SocketIOComponent";
// import { getUserIdFromLC } from "../../helpers/helper";

const Vehicles = () => {
  const { ref, inView } = useInView();
  const [vehicleList, setVehicleList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [activeTab, setActiveTab] = useState("all");

  const getAllVehicles = async (pageNumber, activeTab) => {
    if (!hasMore || isLoading) return;
    setIsLoading(true);
    try {
      const getVehicles = await post("/admin/vehicles-paginate", {
        page: pageNumber,
        limit: 6,
        vehicleStatus: activeTab,
      });
      if (getVehicles.status == 200) {
        setVehicleList((prev) => [...prev, ...getVehicles.data]);
        setHasMore(
          getVehicles.pagination.currentPage < getVehicles.pagination.totalPages
        );
        setIsLoading(false);
      } else {
        setVehicleList([]);
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Error fetching vehicles", error);
    }
  };

  useEffect(() => {
    getAllVehicles(page, activeTab);
  }, [page, activeTab]);

  useEffect(() => {
    if (inView) setPage((prev) => prev + 1);
  }, [inView]);

  const handleTabChange = async (key) => {
    setActiveTab(key);
    setPage(1);
    setVehicleList([]);
    setHasMore(true);
  };
  return (
    <>
      <div className="vehicle">
        <div className="row m-0">
          <div className="col-md-12 col-lg-12 col-xs-12 p-0">
            <h5 className={`page-title text-left`}>Vehicles</h5>
          </div>
          <Tabs
            defaultActiveKey="all"
            id="uncontrolled-tab-example"
            className="vehicle-tabs mb-4"
            onSelect={handleTabChange}
          >
            <Tab
              eventKey="all"
              title={<Translate>all</Translate>}
              color="black"
              style={{ fontWeight: "bold", fontSize: "0.8rem" }}
            ></Tab>
            <Tab
              eventKey="moving"
              title={<Translate>moving</Translate>}
              color="black"
              style={{ fontWeight: "bold", fontSize: "0.8rem" }}
            ></Tab>
            <Tab
              eventKey="offline"
              title={<Translate>offline</Translate>}
              color="black"
              style={{ fontWeight: "bold", fontSize: "0.8rem" }}
            ></Tab>
            <Tab
              eventKey="idle"
              title={<Translate>idle</Translate>}
              color="black"
              style={{ fontWeight: "bold", fontSize: "0.8rem" }}
            ></Tab>
            <Tab
              eventKey="expired"
              title={<Translate>expired</Translate>}
              color="black"
              style={{ fontWeight: "bold", fontSize: "0.8rem" }}
            ></Tab>
          </Tabs>
          <div className="row">
            {Array.isArray(vehicleList) &&
              vehicleList.map((element, i) => {
                const isLastItem = i === vehicleList.length - 1;
                return (
                  <div
                    className="col-md-6 col-lg-4 mb-4 mx-0"
                    key={`vehicle-${i}`}
                    ref={isLastItem ? ref : null}
                  >
                    {element.subscirptionDaysLeft > 0 ? (
                      <Link
                        to={`/vehicles/${element.vehicleNo}`}
                        state={{ id: element._id }}
                        className="text-decoration-none vehicle-info position-relative"
                      >
                        <VehicleElement
                          _id={element._id}
                          ignitionStatus={element.tripVehicleStatus}
                          address={element.address}
                          routeHistoryKm={element.distance}
                          fuelLevel={element.fuel}
                          totalKmTravelled={element.todayKilometers}
                          vehicleNo={element.vehicleNo}
                          coordinates={element.coordinates}
                          isFuel={element.isFuel}
                          ignition={element.ignition}
                          lastRecordTime={element.createdAt}
                          wireCut={element.wireCut}
                          subscirptionDaysLeft={element.subscirptionDaysLeft}
                        />
                      </Link>
                    ) : (
                      <Link className="text-decoration-none vehicle-info position-relative">
                        <div>
                          <VehicleElement
                            _id={element._id}
                            ignitionStatus={element.tripVehicleStatus}
                            address={element.address}
                            routeHistoryKm={element.distance}
                            fuelLevel={"expired"}
                            totalKmTravelled={element.todayKilometers}
                            vehicleNo={element.vehicleNo}
                            coordinates={element.coordinates}
                            isFuel={element.isFuel}
                            ignition={element.ignition}
                            lastRecordTime={element.createdAt}
                            wireCut={element.wireCut}
                            subscirptionDaysLeft={element.subscirptionDaysLeft}
                          />
                        </div>
                      </Link>
                    )}
                  </div>
                );
              })}
            {hasMore && isLoading && <Loading />}
            {!isLoading && vehicleList.length <= 0 && (
              <p>
                <Translate>noVehicleFound</Translate>
              </p>
            )}
            {/* <SocketIOComponent
              endpoint="https://tsocket.fleetstakes.com:9004"
              event="load_vehicles"
              onEvent={handleEvent}
              clientId={getUserIdFromLC()}
            /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Vehicles;
